import { BaseBody } from '../BaseBody.js';
import { CssVars } from '../../../util/CssVars.js';

const glyphname = 'petastiYpsiliRight';
const args = {};

export class PetastiYpsiliRight extends BaseBody {
  constructor() {
    super(glyphname, args);
  }
}
